"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));

var _objectSpread2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Quests = /*#__PURE__*/function () {
  function Quests(client) {
    (0, _classCallCheck2["default"])(this, Quests);
    this.client = client;
  }

  (0, _createClass2["default"])(Quests, [{
    key: "getQuestList",
    value: function getQuestList() {
      var _this$client;

      var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = (0, _objectSpread2["default"])({
        page: 1,
        limit: 500
      }, queryParams);
      var searchParams = new URLSearchParams();
      Object.entries(params).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (value !== undefined && value !== null && value !== '') {
          searchParams.set(key, String(value));
        }
      });
      var query = searchParams.toString();
      var url = "/quests".concat(query ? "?".concat(query) : '');

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_this$client = this.client).get.apply(_this$client, [url].concat(args)).then(function (response) {
        var payload = response === null || response === void 0 ? void 0 : response.data;

        if (payload && !Array.isArray(payload) && Array.isArray(payload.quests)) {
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, response), {}, {
            data: payload.quests
          });
        }

        return response;
      });
    }
  }, {
    key: "updateQuests",
    value: function updateQuests(data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.put("/quests", data, args);
    }
  }, {
    key: "copyQuest",
    value: function copyQuest(data) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.post("/quests/create-from-existing", data, args);
    }
  }, {
    key: "getQuestDetail",
    value: function getQuestDetail(questId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.get("/quests/".concat(questId), args);
    }
  }, {
    key: "getQuestOverview",
    value: function getQuestOverview(questId) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return this.client.get("/quests/".concat(questId, "/overview"), args);
    }
  }, {
    key: "getInquirie",
    value: function getInquirie(questId) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      return this.client.get("/quests/".concat(questId, "/inquiry-custom-form/answers"), args);
    }
  }, {
    key: "enrollInquiry",
    value: function enrollInquiry(questId, inquiryId, data) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
        args[_key7 - 3] = arguments[_key7];
      }

      return this.client.post("/quests/".concat(questId, "/inquiries/").concat(inquiryId, "/enroll"), data, args);
    } // getInquirieDetail(questId, userId, ...args) {
    //   return this.client.get(`/quests/${questId}/inquiries/${userId}`, args)
    // }

  }, {
    key: "getParticipants",
    value: function getParticipants(questId) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return this.client.get("/quests/".concat(questId, "/participants"), args);
    }
  }, {
    key: "getGuidePairingParticipants",
    value: function getGuidePairingParticipants(questId) {
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var searchParams = new URLSearchParams();
      Object.entries(queryParams).forEach(function (_ref3) {
        var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        if (value !== undefined && value !== null && value !== '') {
          searchParams.set(key, String(value));
        }
      });
      var query = searchParams.toString();

      for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
        args[_key9 - 2] = arguments[_key9];
      }

      return this.client.get("/quests/".concat(questId, "/guide-pairing/participants").concat(query ? "?".concat(query) : ''), args);
    }
  }, {
    key: "addUserQuest",
    value: function addUserQuest(questId, data) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
        args[_key10 - 2] = arguments[_key10];
      }

      return this.client.post("/quests/".concat(questId, "/participants"), data, args);
    }
  }, {
    key: "deleteQuestUser",
    value: function deleteQuestUser(questId, userId) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 2 ? _len11 - 2 : 0), _key11 = 2; _key11 < _len11; _key11++) {
        args[_key11 - 2] = arguments[_key11];
      }

      return this.client["delete"]("/quests/".concat(questId, "/participants/").concat(userId), args);
    }
  }, {
    key: "publishQuest",
    value: function publishQuest(questId, data) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 2 ? _len12 - 2 : 0), _key12 = 2; _key12 < _len12; _key12++) {
        args[_key12 - 2] = arguments[_key12];
      }

      return this.client.patch("/quests/".concat(questId, "/status"), data, args);
    }
  }, {
    key: "archiveQuest",
    value: function archiveQuest(questId) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
        args[_key13 - 1] = arguments[_key13];
      }

      return this.client.patch("/quests/".concat(questId, "/archive"), {}, args);
    }
  }, {
    key: "getItinerary",
    value: function getItinerary(questId) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        args[_key14 - 1] = arguments[_key14];
      }

      return this.client.get("/quests/".concat(questId, "/itinerary"), args);
    }
  }, {
    key: "updateItinerary",
    value: function updateItinerary(questId, data) {
      for (var _len15 = arguments.length, args = new Array(_len15 > 2 ? _len15 - 2 : 0), _key15 = 2; _key15 < _len15; _key15++) {
        args[_key15 - 2] = arguments[_key15];
      }

      return this.client.put("/quests/".concat(questId, "/itinerary"), data, args);
    }
  }, {
    key: "changeItinerary",
    value: function changeItinerary(questId, data) {
      for (var _len16 = arguments.length, args = new Array(_len16 > 2 ? _len16 - 2 : 0), _key16 = 2; _key16 < _len16; _key16++) {
        args[_key16 - 2] = arguments[_key16];
      }

      return this.client.put("/quests/".concat(questId, "/change-itinerary"), data, args);
    }
  }, {
    key: "sendItineraryNotification",
    value: function sendItineraryNotification(questId, data) {
      for (var _len17 = arguments.length, args = new Array(_len17 > 2 ? _len17 - 2 : 0), _key17 = 2; _key17 < _len17; _key17++) {
        args[_key17 - 2] = arguments[_key17];
      }

      return this.client.post("/quests/".concat(questId, "/itinerary/notify"), data, args);
    }
  }, {
    key: "getQuestImage",
    value: function getQuestImage(questId, contentType) {
      for (var _len18 = arguments.length, args = new Array(_len18 > 2 ? _len18 - 2 : 0), _key18 = 2; _key18 < _len18; _key18++) {
        args[_key18 - 2] = arguments[_key18];
      }

      return this.client.get("/quests/".concat(questId, "/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "getPartnersSignedURL",
    value: function getPartnersSignedURL(questId, contentType) {
      for (var _len19 = arguments.length, args = new Array(_len19 > 2 ? _len19 - 2 : 0), _key19 = 2; _key19 < _len19; _key19++) {
        args[_key19 - 2] = arguments[_key19];
      }

      return this.client.get("/quests/".concat(questId, "/partnership-logo/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "getVideoPosterSignedURL",
    value: function getVideoPosterSignedURL(questId, contentType) {
      for (var _len20 = arguments.length, args = new Array(_len20 > 2 ? _len20 - 2 : 0), _key20 = 2; _key20 < _len20; _key20++) {
        args[_key20 - 2] = arguments[_key20];
      }

      return this.client.get("/quests/".concat(questId, "/video-poster/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "getJourneySignedURL",
    value: function getJourneySignedURL(questId, contentType) {
      for (var _len21 = arguments.length, args = new Array(_len21 > 2 ? _len21 - 2 : 0), _key21 = 2; _key21 < _len21; _key21++) {
        args[_key21 - 2] = arguments[_key21];
      }

      return this.client.get("/quests/".concat(questId, "/journey-image/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "getClientProfileQuest",
    value: function getClientProfileQuest(clientId) {
      for (var _len22 = arguments.length, args = new Array(_len22 > 1 ? _len22 - 1 : 0), _key22 = 1; _key22 < _len22; _key22++) {
        args[_key22 - 1] = arguments[_key22];
      }

      return this.client.get("/client/".concat(clientId, "/quests"), args);
    }
  }, {
    key: "getClientQuestList",
    value: function getClientQuestList(clientId) {
      var queryParams = {};

      if (clientId) {
        queryParams.clientId = clientId;
      }

      var query = new URLSearchParams(queryParams).toString();
      var url = "/quests/list".concat(query ? "?".concat(query) : '');

      for (var _len23 = arguments.length, args = new Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
        args[_key23 - 1] = arguments[_key23];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getBlogImage",
    value: function getBlogImage(contentType) {
      for (var _len24 = arguments.length, args = new Array(_len24 > 1 ? _len24 - 1 : 0), _key24 = 1; _key24 < _len24; _key24++) {
        args[_key24 - 1] = arguments[_key24];
      }

      return this.client.get("/quests/blogs/signed-url?fileType=".concat(contentType), args);
    }
  }, {
    key: "getCreateBlog",
    value: function getCreateBlog(data) {
      for (var _len25 = arguments.length, args = new Array(_len25 > 1 ? _len25 - 1 : 0), _key25 = 1; _key25 < _len25; _key25++) {
        args[_key25 - 1] = arguments[_key25];
      }

      return this.client.post("/quests/blogs", data, args);
    }
  }, {
    key: "getBlogAll",
    value: function getBlogAll() {
      for (var _len26 = arguments.length, args = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
        args[_key26] = arguments[_key26];
      }

      return this.client.get("/quests/blogs", args);
    }
  }, {
    key: "getAllVideo",
    value: function getAllVideo() {
      for (var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
        args[_key27] = arguments[_key27];
      }

      return this.client.get('/video', args);
    }
  }, {
    key: "getVideoDetail",
    value: function getVideoDetail(videoId) {
      for (var _len28 = arguments.length, args = new Array(_len28 > 1 ? _len28 - 1 : 0), _key28 = 1; _key28 < _len28; _key28++) {
        args[_key28 - 1] = arguments[_key28];
      }

      return this.client.get("/video/".concat(videoId), args);
    }
  }, {
    key: "createVideo",
    value: function createVideo(data) {
      for (var _len29 = arguments.length, args = new Array(_len29 > 1 ? _len29 - 1 : 0), _key29 = 1; _key29 < _len29; _key29++) {
        args[_key29 - 1] = arguments[_key29];
      }

      return this.client.post('/video', data, args);
    }
  }, {
    key: "updateVideo",
    value: function updateVideo(videoId, data) {
      for (var _len30 = arguments.length, args = new Array(_len30 > 2 ? _len30 - 2 : 0), _key30 = 2; _key30 < _len30; _key30++) {
        args[_key30 - 2] = arguments[_key30];
      }

      return this.client.put("/video/".concat(videoId), data, args);
    }
  }, {
    key: "deleteVideo",
    value: function deleteVideo(videoId) {
      for (var _len31 = arguments.length, args = new Array(_len31 > 1 ? _len31 - 1 : 0), _key31 = 1; _key31 < _len31; _key31++) {
        args[_key31 - 1] = arguments[_key31];
      }

      return this.client["delete"]("/video/".concat(videoId), args);
    }
  }, {
    key: "getVideoThumbnailSignedURL",
    value: function getVideoThumbnailSignedURL(contentType) {
      for (var _len32 = arguments.length, args = new Array(_len32 > 1 ? _len32 - 1 : 0), _key32 = 1; _key32 < _len32; _key32++) {
        args[_key32 - 1] = arguments[_key32];
      }

      return this.client.get("/video/signed-url?fileType=".concat(contentType), args);
    }
  }, {
    key: "getBlogDetail",
    value: function getBlogDetail(blogId) {
      for (var _len33 = arguments.length, args = new Array(_len33 > 1 ? _len33 - 1 : 0), _key33 = 1; _key33 < _len33; _key33++) {
        args[_key33 - 1] = arguments[_key33];
      }

      return this.client.get("/quests/blogs/".concat(blogId), args);
    }
  }, {
    key: "getUpdateBlog",
    value: function getUpdateBlog(blogId, data) {
      for (var _len34 = arguments.length, args = new Array(_len34 > 2 ? _len34 - 2 : 0), _key34 = 2; _key34 < _len34; _key34++) {
        args[_key34 - 2] = arguments[_key34];
      }

      return this.client.put("/quests/blogs/".concat(blogId), data, args);
    }
  }, {
    key: "attachAudio",
    value: function attachAudio(questId, mediaId) {
      for (var _len35 = arguments.length, args = new Array(_len35 > 2 ? _len35 - 2 : 0), _key35 = 2; _key35 < _len35; _key35++) {
        args[_key35 - 2] = arguments[_key35];
      }

      return this.client.post("/quests/".concat(questId, "/medias/").concat(mediaId), args);
    }
  }, {
    key: "getQuestResources",
    value: function getQuestResources(questId) {
      for (var _len36 = arguments.length, args = new Array(_len36 > 1 ? _len36 - 1 : 0), _key36 = 1; _key36 < _len36; _key36++) {
        args[_key36 - 1] = arguments[_key36];
      }

      return this.client.get("/quests/".concat(questId, "/medias"), args);
    }
    /**
     * Persist Watch/Read attachment order.
     * @param {string} questId
     * @param {'videos'|'blogs'} resourceType
     * @param {string[]} orderedIds
     */

  }, {
    key: "reorderQuestResources",
    value: function reorderQuestResources(questId, resourceType, orderedIds) {
      var _this$client2;

      for (var _len37 = arguments.length, args = new Array(_len37 > 3 ? _len37 - 3 : 0), _key37 = 3; _key37 < _len37; _key37++) {
        args[_key37 - 3] = arguments[_key37];
      }

      return (_this$client2 = this.client).put.apply(_this$client2, ["/quests/".concat(questId, "/resources/").concat(resourceType, "/order"), {
        orderedIds: orderedIds
      }].concat(args));
    }
  }, {
    key: "getThumbnailSignedURL",
    value: function getThumbnailSignedURL(questId, contentType) {
      for (var _len38 = arguments.length, args = new Array(_len38 > 2 ? _len38 - 2 : 0), _key38 = 2; _key38 < _len38; _key38++) {
        args[_key38 - 2] = arguments[_key38];
      }

      return this.client.get("/quests/".concat(questId, "/videos/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "addVideoToQuest",
    value: function addVideoToQuest(questId, videoId, data) {
      for (var _len39 = arguments.length, args = new Array(_len39 > 3 ? _len39 - 3 : 0), _key39 = 3; _key39 < _len39; _key39++) {
        args[_key39 - 3] = arguments[_key39];
      }

      return this.client.post("/quests/".concat(questId, "/videos/").concat(videoId), data, args);
    }
  }, {
    key: "toggleQuestMedia",
    value: function toggleQuestMedia(questId, mediaId, data) {
      for (var _len40 = arguments.length, args = new Array(_len40 > 3 ? _len40 - 3 : 0), _key40 = 3; _key40 < _len40; _key40++) {
        args[_key40 - 3] = arguments[_key40];
      }

      return this.client.post("/quests/".concat(questId, "/medias/").concat(mediaId), data, args);
    }
  }, {
    key: "toggleBlogMedia",
    value: function toggleBlogMedia(questId, blogId, data) {
      for (var _len41 = arguments.length, args = new Array(_len41 > 3 ? _len41 - 3 : 0), _key41 = 3; _key41 < _len41; _key41++) {
        args[_key41 - 3] = arguments[_key41];
      }

      return this.client.post("/quests/".concat(questId, "/blogs/").concat(blogId), data, args);
    }
  }, {
    key: "deleteQuestVideo",
    value: function deleteQuestVideo(questId, videoId) {
      for (var _len42 = arguments.length, args = new Array(_len42 > 2 ? _len42 - 2 : 0), _key42 = 2; _key42 < _len42; _key42++) {
        args[_key42 - 2] = arguments[_key42];
      }

      return this.client["delete"]("/quests/".concat(questId, "/videos/").concat(videoId), args);
    }
  }, {
    key: "getQuestJourney",
    value: function getQuestJourney(_ref5) {
      var _this$client3;

      var questId = _ref5.questId,
          tabType = _ref5.tabType;
      var url = '/journey';

      if (questId) {
        url += "?questId=".concat(questId);
      }

      if (tabType) {
        url += "?tabType=".concat(tabType);
      }

      for (var _len43 = arguments.length, args = new Array(_len43 > 1 ? _len43 - 1 : 0), _key43 = 1; _key43 < _len43; _key43++) {
        args[_key43 - 1] = arguments[_key43];
      }

      return (_this$client3 = this.client).get.apply(_this$client3, [url].concat(args));
    }
  }, {
    key: "updateQuestJourney",
    value: function updateQuestJourney(questId, data) {
      var _this$client4;

      for (var _len44 = arguments.length, args = new Array(_len44 > 2 ? _len44 - 2 : 0), _key44 = 2; _key44 < _len44; _key44++) {
        args[_key44 - 2] = arguments[_key44];
      }

      return (_this$client4 = this.client).put.apply(_this$client4, ["/journey?questId=".concat(questId), data].concat(args));
    }
  }, {
    key: "getSingleParticipant",
    value: function getSingleParticipant(questId, userId) {
      var _this$client5;

      for (var _len45 = arguments.length, args = new Array(_len45 > 2 ? _len45 - 2 : 0), _key45 = 2; _key45 < _len45; _key45++) {
        args[_key45 - 2] = arguments[_key45];
      }

      return (_this$client5 = this.client).get.apply(_this$client5, ["/quests/".concat(questId, "/participants/").concat(userId)].concat(args));
    }
  }, {
    key: "updateSingleParticipant",
    value: function updateSingleParticipant(questId, userId, data) {
      var _this$client6;

      for (var _len46 = arguments.length, args = new Array(_len46 > 3 ? _len46 - 3 : 0), _key46 = 3; _key46 < _len46; _key46++) {
        args[_key46 - 3] = arguments[_key46];
      }

      return (_this$client6 = this.client).put.apply(_this$client6, ["/quests/".concat(questId, "/participants/").concat(userId), data].concat(args));
    }
  }, {
    key: "addManualPayment",
    value: function addManualPayment(questId, userId, data) {
      var _this$client7;

      for (var _len47 = arguments.length, args = new Array(_len47 > 3 ? _len47 - 3 : 0), _key47 = 3; _key47 < _len47; _key47++) {
        args[_key47 - 3] = arguments[_key47];
      }

      return (_this$client7 = this.client).post.apply(_this$client7, ["/quests/".concat(questId, "/participants/").concat(userId, "/external-payments"), data].concat(args));
    }
  }, {
    key: "resendParticipantInvite",
    value: function resendParticipantInvite(questId, userId) {
      var _this$client8;

      for (var _len48 = arguments.length, args = new Array(_len48 > 2 ? _len48 - 2 : 0), _key48 = 2; _key48 < _len48; _key48++) {
        args[_key48 - 2] = arguments[_key48];
      }

      return (_this$client8 = this.client).post.apply(_this$client8, ["/quests/".concat(questId, "/participants/").concat(userId, "/resent-invitation-email")].concat(args));
    }
  }, {
    key: "generateParticipantInviteLink",
    value: function generateParticipantInviteLink(questId, userId) {
      var _this$client9;

      for (var _len49 = arguments.length, args = new Array(_len49 > 2 ? _len49 - 2 : 0), _key49 = 2; _key49 < _len49; _key49++) {
        args[_key49 - 2] = arguments[_key49];
      }

      return (_this$client9 = this.client).get.apply(_this$client9, ["/quests/".concat(questId, "/participants/").concat(userId, "/invite-link")].concat(args));
    }
  }, {
    key: "getQuestWelcomeEmail",
    value: function getQuestWelcomeEmail(questId) {
      var _this$client10;

      for (var _len50 = arguments.length, args = new Array(_len50 > 1 ? _len50 - 1 : 0), _key50 = 1; _key50 < _len50; _key50++) {
        args[_key50 - 1] = arguments[_key50];
      }

      return (_this$client10 = this.client).get.apply(_this$client10, ["/quests/welcome-email/".concat(questId)].concat(args));
    }
  }, {
    key: "updateQuestWelcomeEmail",
    value: function updateQuestWelcomeEmail(questId, data) {
      var _this$client11;

      for (var _len51 = arguments.length, args = new Array(_len51 > 2 ? _len51 - 2 : 0), _key51 = 2; _key51 < _len51; _key51++) {
        args[_key51 - 2] = arguments[_key51];
      }

      return (_this$client11 = this.client).put.apply(_this$client11, ["/quests/welcome-email/".concat(questId), data].concat(args));
    }
  }, {
    key: "sendQuestWelcomeEmailTest",
    value: function sendQuestWelcomeEmailTest(questId) {
      var _this$client12;

      for (var _len52 = arguments.length, args = new Array(_len52 > 1 ? _len52 - 1 : 0), _key52 = 1; _key52 < _len52; _key52++) {
        args[_key52 - 1] = arguments[_key52];
      }

      return (_this$client12 = this.client).post.apply(_this$client12, ["/quests/welcome-email/".concat(questId, "/test"), {}].concat(args));
    }
  }, {
    key: "updateCustomForm",
    value: function updateCustomForm(questId, data) {
      var _this$client13;

      for (var _len53 = arguments.length, args = new Array(_len53 > 2 ? _len53 - 2 : 0), _key53 = 2; _key53 < _len53; _key53++) {
        args[_key53 - 2] = arguments[_key53];
      }

      return (_this$client13 = this.client).put.apply(_this$client13, ["/quests/".concat(questId, "/custom-form"), data].concat(args));
    }
  }, {
    key: "updateInquiryCustomForm",
    value: function updateInquiryCustomForm(questId, data) {
      var _this$client14;

      for (var _len54 = arguments.length, args = new Array(_len54 > 2 ? _len54 - 2 : 0), _key54 = 2; _key54 < _len54; _key54++) {
        args[_key54 - 2] = arguments[_key54];
      }

      return (_this$client14 = this.client).put.apply(_this$client14, ["/quests/".concat(questId, "/inquiry-custom-form"), data].concat(args));
    }
  }, {
    key: "getCustomFormRecipients",
    value: function getCustomFormRecipients(questId) {
      var _this$client15;

      for (var _len55 = arguments.length, args = new Array(_len55 > 1 ? _len55 - 1 : 0), _key55 = 1; _key55 < _len55; _key55++) {
        args[_key55 - 1] = arguments[_key55];
      }

      return (_this$client15 = this.client).get.apply(_this$client15, ["/quests/".concat(questId, "/custom-form/recipients")].concat(args));
    }
  }, {
    key: "getTypeformImage",
    value: function getTypeformImage(questId, contentType) {
      for (var _len56 = arguments.length, args = new Array(_len56 > 2 ? _len56 - 2 : 0), _key56 = 2; _key56 < _len56; _key56++) {
        args[_key56 - 2] = arguments[_key56];
      }

      return this.client.get("/quests/".concat(questId, "/custom-form/question-image/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "removeQuestionImage",
    value: function removeQuestionImage(questId, customFormId, questionId) {
      var _this$client16;

      for (var _len57 = arguments.length, args = new Array(_len57 > 3 ? _len57 - 3 : 0), _key57 = 3; _key57 < _len57; _key57++) {
        args[_key57 - 3] = arguments[_key57];
      }

      return (_this$client16 = this.client)["delete"].apply(_this$client16, ["/quests/".concat(questId, "/custom-form/question-image?customFormId=").concat(customFormId, "&questionId=").concat(questionId)].concat(args));
    }
  }, {
    key: "deleteQuestion",
    value: function deleteQuestion(questId, customFormId, questionId, data) {
      var _this$client17;

      for (var _len58 = arguments.length, args = new Array(_len58 > 4 ? _len58 - 4 : 0), _key58 = 4; _key58 < _len58; _key58++) {
        args[_key58 - 4] = arguments[_key58];
      }

      return (_this$client17 = this.client)["delete"].apply(_this$client17, ["/quests/".concat(questId, "/custom-form/").concat(customFormId, "/question/").concat(questionId), data].concat(args));
    }
  }, {
    key: "deleteCustomFormAnswers",
    value: function deleteCustomFormAnswers(questId, participantId, customFormId) {
      var _this$client18;

      for (var _len59 = arguments.length, args = new Array(_len59 > 3 ? _len59 - 3 : 0), _key59 = 3; _key59 < _len59; _key59++) {
        args[_key59 - 3] = arguments[_key59];
      }

      return (_this$client18 = this.client)["delete"].apply(_this$client18, ["/quests/".concat(questId, "/participants/").concat(participantId, "/custom-form/").concat(customFormId, "/answers")].concat(args));
    }
  }]);
  return Quests;
}();

exports["default"] = Quests;